// Maintenance.js
import React from "react";

function Maintenance() {
  return (
    <div style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "100vh",
      backgroundColor: "#f0f0f0"
    }}>
      <h1>🚧 Site is Under Maintenance 🚧</h1>
    </div>
  );
}

export default Maintenance;
